import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import Logger from './logger';
import type { PrimitiveData } from './types';

// Tenants opt out via the doNotRecordTenantOrgIdOnLogRocket flag; sandbox
// configs are skipped because they are never live.
export const shouldRecordTenantSession = (config: OnboardingSessionConfig): boolean =>
  config.isLive && !config.flags.doNotRecordTenantOrgIdOnLogRocket;

// Starts session replay and attaches tenant identity (tenant_id / tenant_name / playbook key)
// to all Datadog logs + RUM events for the rest of the page lifetime. Apps
// pass `extras` for any additional context they want pinned alongside.
export const setTenantLogContext = (config: OnboardingSessionConfig, extras: PrimitiveData = {}): void => {
  Logger.startSessionReplay();
  Logger.setGlobalContext({
    tenant_id: config.orgId,
    tenant_name: config.orgName,
    playbook_key: config.key,
    ...extras,
  });
};
